"use client";

import CustomImage from '@/components/image';
import HcpGraphNumber from '@/components-hcp/graph-number'
import styles from './_hcp-administration.module.scss';

export default function HcpDosingAdministration() {
  return (
    <section className={styles.admin}>
      <div className={`container ${styles.admin_container}`}>
        <h2 className={styles.admin_heading}>CRENESSITY administration</h2>
        <ul className={styles.admin_options}>
          <li className={styles.admin_option}>
            <div className={styles.admin_option_heading}>CRENESSITY should be taken twice a day<sup>1</sup></div>
            <div className={styles.content}>
              <p className={styles.admin_option_body_first}>CRENESSITY should be taken in the morning and evening. CRENESSITY dosing can be timed with GC doses.</p>
            </div>
            <CustomImage
              className={styles.admin_option_image}
              src='/images/components/hcp/Dosing-Schedule-Icon.svg'
              width={98}
              height={110}
              alt=''
            />
          </li>
          <li className={styles.admin_option}>
            <div className={styles.admin_option_heading}>CRENESSITY must be taken with a meal<sup>1,4</sup></div>
            <div className={styles.content}>
              <p className="mb-4">CRENESSITY works best when taken with food containing at least <span className="text-nowrap">5 g</span> of fat. Instruct patients to take CRENESSITY with foods like:</p>
              <ul>
                <li>A glass of whole, 2%, or chocolate milk (not skim)</li>
                <li>A glass of full-fat oat milk</li>
                <li>Crackers with cheese or peanut butter</li>
                <li>A granola bar with nuts</li>
                <li>Half an avocado</li>
                <li>An apple with peanut <br />butter</li>
              </ul>
            </div>
            <CustomImage
              className={`${styles.admin_option_image}`}
              src='/images/components/hcp/Meal-Icon.svg'
              width={114}
              height={110}
              alt=''
            />
          </li>
          <li className={styles.admin_option}>
            <div className={styles.admin_option_heading}>CRENESSITY is available as capsules and as an oral solution<sup>1</sup></div>
            <div className={styles.content}>
              <p>Capsules should be swallowed whole with liquid and not opened, chewed, or broken. Oral solution should not be diluted and should be taken with an oral syringe.</p>
            </div>
            <CustomImage
              className={styles.admin_option_image}
              src='/images/components/hcp/Capsules-Oral-Solution-Icon.svg'
              width={132}
              height={121}
              alt=''
            />
          </li>
        </ul>
        <div className={styles.admin_easy}>
          <div className={styles.admin_easy_percent}>
            { /* more correct but doest match figma so commented out for now
            <HcpGraphNumber 
              percentage={70.2}
              color="#652C8E"
              innerCircle = {false}
            /> */ }
            <CustomImage
              className={styles.admin_easy_image}
              src='/images/components/Dosing_70-Percent-Chart.svg'
              width={291}
              height={292}
              alt='Approximately 70% of pediatric patients rated the oral solution as easy or very easy to take.' />
          </div>
          <p className={styles.admin_easy_claim}>of pediatric patients rated the oral solution as easy or very easy to take (n=35).<sup>5</sup></p>
          <p className={styles.admin_easy_note}>Patients aged 6-17 years rated ease of administration on a 5-option scale ranging from very difficult to very easy.<sup>5</sup></p>
        </div>
      </div>
    </section>
  );
}
